import type { DeepPartial } from '@nuxt/ui'
import type theme from '#build/ui/button'

const button: DeepPartial<typeof theme> = {
  slots: {
    base: ['transitions-normal inline-flex items-center font-bold rounded-xl focus:outline-hidden focus-visible:outline-2 focus-visible:outline-current focus-visible:outline-offset-2 disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-100 aria-disabled:opacity-100'],
    label: 'truncate',
    leadingIcon: 'transitions-normal shrink-0',
    leadingAvatar: 'transitions-normal shrink-0',
    leadingAvatarSize: '',
    trailingIcon: 'transitions-normal shrink-0',
  },
  variants: {
    size: {
      xs: {
        base: 'gap-1 px-2 py-1 text-xs',
        leadingIcon: 'size-4',
        leadingAvatarSize: '3xs',
        trailingIcon: 'size-4',
      },
      sm: {
        base: 'gap-1.5 px-2.5 py-1.5 text-xs',
        leadingIcon: 'size-4',
        leadingAvatarSize: '3xs',
        trailingIcon: 'size-4',
      },
      md: {
        base: 'gap-1.5 px-2.5 py-1.5 text-sm',
        leadingIcon: 'size-5',
        leadingAvatarSize: '2xs',
        trailingIcon: 'size-5',
      },
      lg: {
        base: 'gap-2 px-4 py-2.5 text-sm',
        leadingIcon: 'size-5',
        leadingAvatarSize: '2xs',
        trailingIcon: 'size-5',
      },
      xl: {
        base: 'gap-2 px-6 py-4 text-base',
        leadingIcon: 'size-6',
        leadingAvatarSize: 'xs',
        trailingIcon: 'size-6',
      },
    },
  },
  compoundVariants: [{
    color: 'primary',
    variant: 'solid',
    class: 'bg-med-deep-navy text-white min-w-[170px] justify-center max-w-full no-underline text-center hover:bg-[var(--ui-button-hover-bg)] hover:text-[var(--ui-button-hover-text)]',
  }, {
    color: 'secondary',
    variant: 'solid',
    class: 'bg-med-navy text-white min-w-[170px] justify-center max-w-full no-underline text-center hover:bg-primary hover:text-[var(--ui-button-hover-text)]',
  }, {
    color: 'info',
    variant: 'solid',
    class: 'bg-med-aqua text-med-deep-navy min-w-[170px] justify-center max-w-full no-underline text-center hover:bg-[var(--ui-button-hover-bg)] hover:text-[var(--ui-button-hover-text)]',
  }, {
    color: 'warning',
    variant: 'solid',
    class: 'bg-med-orange text-white min-w-[170px] justify-center max-w-full no-underline text-center hover:bg-[var(--ui-button-warning-hover-bg)] hover:text-[var(--ui-button-hover-text)]',
  }, {
    color: 'primary',
    variant: 'pagination' as any,
    class: '',
  }, {
    color: 'primary',
    variant: 'outline',
    class: 'bg-transparent text-med-deep-navy shadow-none ring-0 border-current border-2 min-w-[170px] justify-center max-w-full no-underline text-center hover:bg-[var(--ui-med-navy)] hover:text-[var(--ui-button-hover-text)]',
  }, {
    color: 'primary',
    variant: 'link',
    class: '',
  }, {
    color: 'neutral',
    variant: 'solid',
    class: 'bg-white text-med-deep-navy min-w-[170px] justify-center max-w-full no-underline text-center border-med-deep-navy border-2 hover:bg-[var(--ui-med-navy)] hover:text-[var(--ui-button-hover-text)]',
  }, {
    size: 'xs',
    square: true,
    class: 'p-1',
  }, {
    size: 'sm',
    square: true,
    class: 'p-1.5',
  }, {
    size: 'md',
    square: true,
    class: 'p-1.5',
  }, {
    size: 'lg',
    square: true,
    class: 'p-2',
  }, {
    size: 'xl',
    square: true,
    class: 'p-2',
  }, {
    loading: true,
    leading: true,
    class: {
      leadingIcon: 'animate-spin',
    },
  }, {
    loading: true,
    leading: false,
    trailing: true,
    class: {
      trailingIcon: 'animate-spin',
    },
  }],
  defaultVariants: {
    color: 'primary',
    variant: 'solid',
    size: 'lg',
  },
}

export default button
